import { useEffect } from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PlusIcon from "../../../assets/icons/PlusIcon";
import Spinner from "../../../assets/icons/Spinner";
import Message from "../../../i18n/Message";
import WorkspaceLayout from "../../shared/layout/WorkspaceLayout";
import { loadForms } from "../store/formActionCreators";
import { formSelectors } from "../store/formReducer";
import EditFormDialog from "./EditFormDialog";
import FormTile from "./FormTile";

import "./FormListPage.scss";
import { loadPrompts } from "../../prompt/store/promptActionCreators";

const FormListPage = () => {
  const [showCreate, setShowCreate] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { workspaceId } = useParams();
  const formList = useSelector(formSelectors.getList);
  const listCounter = useSelector(formSelectors.getListCounter);

  useEffect(() => {
    if (workspaceId) {
      dispatch(loadForms(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId, listCounter]);

  useEffect(() => {
    if (workspaceId) {
      dispatch(loadPrompts(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId]);

  return (
    <WorkspaceLayout contentPanelClassName="campaign_list_main">
      <div className="body_content card">
        <div className="content_header">
          <h1>
            <Message id="forms_title" />
          </h1>
          <div>
            <button
              className="btn bg-gradient-primary"
              onClick={() => setShowCreate(true)}
            >
              <PlusIcon size="18" color="#fff" />
              <Message id="create_form" />
            </button>
          </div>
        </div>
        <div className="campaign_tiles">
          {!formList && <Spinner />}
          {formList &&
            formList.map((form) => <FormTile key={form.uid} form={form} />)}
        </div>
      </div>
      {showCreate && <EditFormDialog onClose={() => setShowCreate(false)} />}
    </WorkspaceLayout>
  );
};

export default FormListPage;
